<template>
<v-container pa-5 style="background-color:#f3f3f3; padding:3px" flat >
    <v-row >
          <v-col cols="12" align="center"><h1 class="font-weight-light">Il tuo estratto conto</h1></v-col>    
        </v-row >
            <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        :loading="loading"
      >
    <v-card style="padding:10px;" width="100%">
      <v-row   v-for="(grp,chiave) in righegrp"  :key="grp.key">
        <v-col>
          <v-row style="padding: 10px;">{{labels[chiave]}}</v-row>
        <v-row   v-for="riga in grp.filter(x=>x.Totale >=0)" :key="riga.id" >
            <v-col  align="left" class="font-weight-light" style ="font-size:1.1em;"> {{riga.Quantita}} {{riga.Descrizione}} </v-col>
            <v-col  align="right" class="font-weight-light" style ="font-size:1.1em;" >{{(riga.Totale/100).toFixed(2)}} €</v-col>
          </v-row> 
        </v-col>
      </v-row> 

        <!-- <v-row   v-for="riga in righe.filter(x=>x.Totale >=0)" :key="riga.id" >
          <v-col  align="left" class="font-weight-light" style ="font-size:1.1em;"> {{riga.Quantita}} {{riga.Descrizione}} </v-col>
          <v-col  align="right" class="font-weight-light" style ="font-size:1.1em;" >{{(riga.Totale/100).toFixed(2)}} €</v-col>
        </v-row>
          -->
        <v-row   v-for="riga in righe.filter(x=>x.Totale <0)" :key="riga.id" >
          <v-col  align="left" class="font-weight-light" style ="font-size:1.1em;">{{riga.Quantita}} {{riga.Descrizione}} </v-col>
          <v-col  align="right"  class="font-weight-light" style ="font-size:1.1em;" >{{(riga.Totale/100).toFixed(2)}} €</v-col>    
        </v-row>


        <v-row >
 
          <v-col></v-col>   
          <v-col  align="right" class="font-weight-light"  style ="font-size:1.5em;" >Totale {{(this.importo_da_pagare/100).toFixed(2)}} €</v-col>

        </v-row >
</v-card>
            </v-skeleton-loader>

    </v-container>
</template>
<script>
export default {
       data: () => ({
           righe:[],
           righegrp:[],
           loading:false
       }),
  computed:{
      importo_da_pagare(){
          let t =0;
          for (let index = 0; index < this.righe.length; index++) {
              const element = this.righe[index];
              t+= Number(element.Totale);
              
          }
          return t;
      },
      labels(){
        return this.$store.state.labels;
        }
      },
    methods: {
      groupBy:function(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      },
    getec: function() {
      this.loading = true
      const payload = {
        Comando: "GetEstrattoContoPren",
        IdPrenotazione: this.$store.state.reservation.pmsid
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.statusText == "OK") {
          me.righe = risp.data.RISULTATOJSON.riga;
          me.righegrp = this.groupBy( me.righe,'Tipo');
          console.log('gruppo',me.righegrp)
        }
        this.loading = false
      });
    }
  },
       mounted() {
           this.getec()
       },
}
</script>